import { createAsyncThunk } from '@reduxjs/toolkit';

import { type AsyncThunkConfig } from 'types/types';
import { type NotificationType } from 'types/enums';

type Notification = {
  type: keyof typeof NotificationType;
  message: string;
};

const notify = createAsyncThunk<unknown, Notification, AsyncThunkConfig>(
  'notification/notification',
  (payload: Notification, { extra }) => {
    const { notification } = extra;

    notification[payload.type](payload.message);
  },
);

export { notify };
